export default __webpack_public_path__ + "static/sticky_notes-e0b6903cc25b701144bbae3b53144c82.jpg";